// Components
import Owners from "../components/about/Owners";
import Hero from "../components/layout/Hero"
import { useTranslation } from "../hooks/useTranslation";
import heroImg from "../assets/images/about/hero.jpg";

export default function About(params) {
    const t = useTranslation();

    return (
        <section id="aboutSection">
            <Hero
                bgImage={heroImg}
                title={t("about.title")}
            />
            <Owners />
        </section>
    )
}